'use strict';
import template from './listadoBono.html';
import controller from './listadoBono.controller';

const ListadoMunicipiosComponent = {
  controller,
  template
};

export default ListadoMunicipiosComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/listadoBono/listadoBono.component.js